import { FC } from "react";
import { Typography } from "antd";
import { ShopOutlined, RightOutlined } from "@ant-design/icons";
import { useAppDispatch } from "store";
import { openFactorySetup } from "store/slices/layoutSlice";

const { Text } = Typography;

/**
 * ป้ายแทนชื่อ/โลโก้มุมซ้ายบน สำหรับร้านที่ยังตั้งค่าไม่ครบ
 *
 * ช่องนั้นอ่านจาก `contact.image_url` / `contact.name` ซึ่งยังว่างอยู่ — ปล่อยไว้ก็ได้
 * กรอบรูปแตกกับบรรทัดเปล่า ๆ ที่ไม่บอกอะไรเลย เอาที่ตรงนั้นมาเป็นทางกลับเข้า dialog แทน
 * (ผู้ใช้ที่กด "ไว้ทีหลัง" ไปแล้วต้องมีทางกลับมาทำต่อ ไม่ใช่ต้องรอเปิดระบบรอบหน้า)
 */
const FactorySetupBrandButton: FC = () => {
  const dispatch = useAppDispatch();

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => dispatch(openFactorySetup())}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") dispatch(openFactorySetup());
      }}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        margin: "12px 16px",
        padding: "10px 12px",
        borderRadius: 10,
        border: "1px dashed #91caff",
        background: "#f0f7ff",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          flex: "none",
          width: 34,
          height: 34,
          borderRadius: 8,
          background: "#1890ff",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 17,
        }}
      >
        <ShopOutlined />
      </div>
      <div style={{ minWidth: 0, flex: 1, lineHeight: 1.3 }}>
        <Text strong style={{ display: "block", fontSize: 13 }}>
          ตั้งค่าข้อมูลผู้ประกอบการ
        </Text>
        <Text type="secondary" style={{ fontSize: 11 }}>
          ยังกรอกไม่ครบ — กดเพื่อกรอกต่อ
        </Text>
      </div>
      <RightOutlined style={{ fontSize: 11, color: "#1890ff" }} />
    </div>
  );
};

export default FactorySetupBrandButton;
